import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import { hubClient, type Me } from '../services/hubClient';

const MeContext = createContext<Me | null>(null);

/** Loads GET /api/me once after sign-in. Null while loading or on error (the server still decides). */
export function MeProvider({ children }: { children: ReactNode }) {
  const [me, setMe] = useState<Me | null>(null);
  useEffect(() => {
    hubClient.me().then(setMe).catch(() => setMe(null));
  }, []);
  return <MeContext.Provider value={me}>{children}</MeContext.Provider>;
}

export function useMe(): Me | null {
  return useContext(MeContext);
}

/** Platform nav is hidden only once enforcement is on and the caller is not a global admin. */
export function showPlatform(me: Me | null): boolean {
  if (!me || me.kind === 'service' || me.authzMode !== 'enforce') return true;
  return me.isGlobalAdmin;
}
